import Vue from 'vue';
import Swiper from '@/components/swiper/Swiper.vue';
export default Vue.extend({
    components: { Swiper },
    props: {
        brands: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            swiperOptions: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: 2,
                slidesPerGroup: 2,
                watchOverflow: true,
                autoplay: true,
                autoHeight: true,
                loop: true,
                breakpoints: {
                    992: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 10,
                    },
                },
            },
        };
    },
});
